import { ProjectAccessType } from '~/client/graph'
import { InviteStatusCaption } from '~/client/src/shared/enums/InviteStatusCaption'
import User from '~/client/src/shared/models/User'

export enum UserDirectoryColumnId {
  Checkbox = 'checkbox',
  Name = 'name',
  JobTitle = 'jobTitle',
  Email = 'email',
  Phone = 'phone',
  Status = 'status',
  AccountType = 'accountType',
  AccountPosition = 'accountPosition',
  Roles = 'roles',
  Trades = 'trades',
  Teams = 'teams',
  UserTags = 'userTags',
  EmployeeId = 'employeeId',
  Actions = 'actions',
}

export const GROUPING_COLUMN_ID = 'companyId'

export interface IUserRow {
  id: string
  user: User
  companyId: string
  companyName: string
  fullName: string
  firstName: string
  lastName: string
  jobTitle: string
  status: InviteStatusCaption
  rolesIds: string[]
  tradesIds: string[]
  teamsIds: string[]
  userTagIds: string[]
  accountPosition: string
  accountType: ProjectAccessType
  email: string
  phone: string
  employeeId: string
  canBeInvited: boolean
  canBeApproved: boolean
  canBeSetNotInvited: boolean
}

export type PrimaryModalKey = 'addUser' | 'bulkEdit' | 'procore' | null

export type ConfirmModalKey =
  | 'invite'
  | 'approve'
  | 'setNotInvited'
  | 'delete'
  | null
